'use client';
import React from 'react';

export default function DriveXFinalCTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="dx-font dx-grid-texture"
      style={{ background: '#0A0A0A', padding: '120px 0', textAlign: 'center' }}
    >
      <div className="max-w-4xl mx-auto px-6">
        <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: 'clamp(36px, 5vw, 64px)', color: '#FFFFFF', letterSpacing: '-0.025em', textTransform: 'uppercase', lineHeight: 0.95, marginBottom: '20px' }}>
          Tu competencia ya está<br />
          <span style={{ color: '#C8102E' }}>digitalizando su concesionario.</span>
        </h2>
        <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '18px', color: '#888888', marginBottom: '40px' }}>
          Cada día sin DriveX es un lead perdido.
        </p>
        <div className="flex justify-center">
          <button
            onClick={() => scrollTo('pricing')}
            className="dx-pulse"
            style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800, fontSize: '15px', color: '#FFFFFF', background: '#C8102E', padding: '20px 56px', borderRadius: '4px', border: 'none', cursor: 'pointer', letterSpacing: '0.15em', textTransform: 'uppercase', maxWidth: '380px', width: '100%', transition: 'background 0.2s ease' }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.background = '#9B0D22')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.background = '#C8102E')}
          >
            EMPEZAR HOY — 14 DÍAS GRATIS
          </button>
        </div>
        <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '11px', color: '#888888', letterSpacing: '0.05em', marginTop: '16px' }}>
          Sin tarjeta de crédito · Cancela cuando quieras · Configuración en 5 minutos
        </p>
      </div>
    </section>
  );
}
